import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function NFCConsulting() {
  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">NFC Consulting</h1>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16 space-y-12">
        <Block title="Overview">
          TapTrack has expertise in multiple areas of NFC technology and can provide consulting on many different
          facets of NFC solution development.
        </Block>

        <Block title="Application Development">
          If you are considering an application that uses NFC, TapTrack can provide consulting for the entire NFC
          stack required to enable your application. From tag selection all the way to custom reader design, TapTrack
          can consult on any facet of your application’s NFC requirements in order to make the NFC integration as
          painless as possible.
        </Block>

        <Block title="Hardware Design">
          TapTrack has significant experience with custom NFC reader development. Our own Tappy NFC reader was
          developed in-house as well as custom reader projects for various clients supporting ISO/IEC 14443 and 15693
          standard. TapTrack’s hardware design services include the following:
          <ul className="mt-5 grid sm:grid-cols-2 gap-x-8 gap-y-3">
            {[
              "Schematic Capture",
              "PCB Layout",
              "NFC Firmware Development",
              "Managing Bareboard Manufacture",
              "Managing PCB Assembly",
              "Testing",
            ].map((item) => (
              <li key={item} className="flex items-center gap-3 text-slate-700">
                <Check className="w-4 h-4 text-[#29abe2] flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </Block>

        <Block title="NFC Antenna Design and Testing">
          The antenna design is one of the most important parts of any NFC reader design project. Even the most
          powerful amplified reader chips will provide poor performance when paired with a poorly optimized antenna.
          Our engineers use a three-pronged approach using network analyzers, the latest RF design software, and read
          range performance measurements to achieve the best results. If required, we can also implement external
          amplification to increase the power output of the NFC reader chip.
        </Block>

        <div className="pt-6">
          <Link
            to="/contact-us"
            className="inline-block bg-[#29abe2] hover:bg-[#1f9bd0] text-white font-semibold tracking-widest text-sm px-10 py-4 rounded transition-colors"
          >
            CONTACT US
          </Link>
        </div>
      </div>
    </div>
  );
}

function Block({ title, children }) {
  return (
    <div>
      <h2 className="text-2xl md:text-3xl font-semibold text-slate-800 mb-4">{title}</h2>
      <div className="text-slate-600 leading-relaxed text-[16px]">{children}</div>
    </div>
  );
}
